import {
  AppsDeOrigen,
  BigDecimal,
  ConfiguracionesCorreo,
  ConfiguracionesEmpresa,
  ConstantesDocumentos,
  ContaDocs,
  CuentasEnlace,
  Docs,
  DocumentoDominio,
  E_AMBIENTE,
  Ecuador,
  ExisteEnEnum,
  FormasPagoEspeciales,
  HTTP_STATUS,
  LogisticaEstadoConversion,
  LogisticaGuiaEstado,
  LogisticaGuiaProformaEstado,
  LogisticaManifiestoDetalleEstado,
  LogisticaManifiestoProformaEstado,
  LogisticaTipoCanal,
  LogisticaTipoConversion,
  LogisticaTipoFormaPagoDominio,
  LogisticaTiposEntrega,
  LogisticaTiposFormaPago,
  LogisticaTiposRango,
  Modulos,
  MovimientoCabeceraObservacionesEspeciales,
  Movs,
  NivelLog,
  Notificaciones,
  Permisos,
  SriDocs,
  TablasTransacciones,
  TipoCanalVenta,
  TiposAPI,
  TiposDocumento,
  TiposEmision,
  TiposFormaPago,
  TiposIVA,
  TiposIdentificacion,
  TiposPago,
  TiposVisita,
  TiposVisitaSegunUbicacion,
  __name,
  __publicField,
  estadoLogisticaManifiestoProformaDetalle,
  estadoMOVIMIENTOCABECERA,
  estadoUsuario,
  logisticaManifiestoDetalleEstado,
  logisticaManifiestoEstado,
  logisticaOrigen,
  logisticaTipoContenido,
  logisticaTipoContenidoDominio,
  logisticaTipoMedida,
  porcentajeIVA,
  tiposImporteCabecera
} from "./chunk-7A3VL7FR.mjs";

// src/CiudadDTO.ts
var CiudadDTO = class {
  constructor(id, nombre, habilitado, idProvincia, Provincia, Cobertura) {
    __publicField(this, "id");
    __publicField(this, "nombre", "");
    __publicField(this, "habilitado", false);
    __publicField(this, "idProvincia");
    __publicField(this, "Provincia");
    __publicField(this, "Cobertura");
    this.id = id;
    this.nombre = nombre;
    this.habilitado = habilitado;
    this.idProvincia = idProvincia;
    this.Provincia = Provincia;
    this.Cobertura = Cobertura;
  }
};
__name(CiudadDTO, "CiudadDTO");
var CoberturaDTO = class {
  constructor(idCiudadDestino, idTipoDestino) {
    __publicField(this, "idCiudadDestino");
    __publicField(this, "idTipoDestino");
    this.idCiudadDestino = idCiudadDestino;
    this.idTipoDestino = idTipoDestino;
  }
};
__name(CoberturaDTO, "CoberturaDTO");

// src/ClienteDTO.ts
var ClienteDTO = class {
  constructor(id, idTipoIdentificacion, identificacion, razonSocial, nombreComercial, direccion, idCiudad, telefono, celular, email, habilitado) {
    __publicField(this, "id", 0);
    __publicField(this, "idTipoIdentificacion", TiposIdentificacion.RUC);
    __publicField(this, "identificacion", "");
    __publicField(this, "razonSocial", "");
    __publicField(this, "nombreComercial", "");
    __publicField(this, "direccion", "");
    __publicField(this, "idCiudad");
    __publicField(this, "telefono", "");
    __publicField(this, "celular");
    __publicField(this, "email");
    __publicField(this, "habilitado", true);
    this.id = id;
    this.idTipoIdentificacion = idTipoIdentificacion;
    this.identificacion = identificacion;
    this.razonSocial = razonSocial;
    this.nombreComercial = nombreComercial;
    this.direccion = direccion;
    this.idCiudad = idCiudad;
    this.telefono = telefono;
    this.celular = celular;
    this.email = email;
    this.habilitado = habilitado;
  }
};
__name(ClienteDTO, "ClienteDTO");

// src/DateRange.ts
var DateRange = class {
  constructor(start, end) {
    __publicField(this, "start", /* @__PURE__ */ new Date());
    __publicField(this, "end", /* @__PURE__ */ new Date());
    this.start = start;
    this.end = end;
  }
};
__name(DateRange, "DateRange");

// src/CobroDTO.ts
var CobroDTO = class {
  constructor() {
    __publicField(this, "monto", new BigDecimal(0));
    __publicField(this, "montoStr", "0");
    __publicField(this, "idFormaPago", 0);
    __publicField(this, "FORMAPAGO");
    __publicField(this, "observacion");
    __publicField(this, "entidadFinanciera");
    __publicField(this, "idTipoTarjeta");
    __publicField(this, "idBancoTarjeta");
    __publicField(this, "idMarcaTarjeta");
    __publicField(this, "fechaCheque");
    __publicField(this, "numeroCheque");
    __publicField(this, "numeroCuenta");
  }
};
__name(CobroDTO, "CobroDTO");

// src/EnviarCorreoBody.ts
var EnviarCorreoBody = class {
  constructor(id, email) {
    __publicField(this, "id", 0);
    __publicField(this, "email", "");
    this.id = id;
    this.email = email;
  }
};
__name(EnviarCorreoBody, "EnviarCorreoBody");

// src/LoginRequestBody.ts
var LoginRequestBody = class {
  constructor(usuario, password) {
    __publicField(this, "usuario", "");
    __publicField(this, "password", "");
    this.usuario = usuario;
    this.password = password;
  }
};
__name(LoginRequestBody, "LoginRequestBody");

// src/utils/ClassTransformerDecimalTransform.ts
import { Transform } from "class-transformer";
function ClassTransformerBigDecimalTransform() {
  const toPlain = Transform((value) => {
    if (value === null) {
      return null;
    } else if (value === void 0) {
      return void 0;
    } else {
      return value.toFixed(6);
    }
  }, {
    toPlainOnly: true
  });
  const toClass = Transform((value) => {
    if (value === null) {
      return null;
    } else if (value === void 0) {
      return void 0;
    } else {
      return new BigDecimal(value);
    }
  }, {
    toClassOnly: true
  });
  return function(target, key) {
    toPlain(target, key);
    toClass(target, key);
  };
}
__name(ClassTransformerBigDecimalTransform, "ClassTransformerBigDecimalTransform");

// src/LogisticaContenidoDTO.ts
function _ts_decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate, "_ts_decorate");
function _ts_metadata(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
}
__name(_ts_metadata, "_ts_metadata");
var LogisticaContenidoDTO = class {
  constructor() {
    __publicField(this, "id");
    __publicField(this, "idCliente", 0);
    __publicField(this, "descripcion", "");
    __publicField(this, "precio", new BigDecimal("0"));
    __publicField(this, "idTipoIva");
    __publicField(this, "esBulto", false);
    __publicField(this, "habilitado");
    __publicField(this, "cantidadMaxima");
  }
};
__name(LogisticaContenidoDTO, "LogisticaContenidoDTO");
_ts_decorate([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaContenidoDTO.prototype, "precio", void 0);
_ts_decorate([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaContenidoDTO.prototype, "cantidadMaxima", void 0);
var LogisticaContenidoPorDestinoDTO = class extends LogisticaContenidoDTO {
  constructor(id, idCliente, descripcion, precio, idTipoIva, esBulto, idCiudadOrigen, idCiudadDestino, habilitado, cantidadMaxima) {
    super();
    __publicField(this, "idCiudadOrigen");
    __publicField(this, "idCiudadDestino");
    this.id = id;
    this.idCliente = idCliente;
    this.descripcion = descripcion;
    this.precio = precio;
    this.idTipoIva = idTipoIva;
    this.esBulto = esBulto;
    this.idCiudadOrigen = idCiudadOrigen;
    this.idCiudadDestino = idCiudadDestino;
    this.habilitado = habilitado;
  }
};
__name(LogisticaContenidoPorDestinoDTO, "LogisticaContenidoPorDestinoDTO");
var LogisticaContenidoPorTipoDestinoDTO = class extends LogisticaContenidoDTO {
  constructor(id, idCliente, descripcion, precio, idTipoIva, esBulto, idTipoDestino, habilitado, cantidadMaxima) {
    super();
    __publicField(this, "idTipoDestino");
    this.id = id;
    this.idCliente = idCliente;
    this.descripcion = descripcion;
    this.precio = precio;
    this.idTipoIva = idTipoIva;
    this.esBulto = esBulto;
    this.idTipoDestino = idTipoDestino;
    this.habilitado = habilitado;
    this.cantidadMaxima = cantidadMaxima;
  }
};
__name(LogisticaContenidoPorTipoDestinoDTO, "LogisticaContenidoPorTipoDestinoDTO");
var TipoContenido = /* @__PURE__ */ function(TipoContenido2) {
  TipoContenido2["PorDestino"] = "PorDestino";
  TipoContenido2["PorTipoDestino"] = "PorTipoDestino";
  return TipoContenido2;
}({});
var LogisticaContenidoRespuestaDTO = class {
  constructor(_tipo, _contenidos) {
    __publicField(this, "tipo");
    __publicField(this, "contenidos");
    this.tipo = _tipo;
    this.contenidos = _contenidos;
  }
};
__name(LogisticaContenidoRespuestaDTO, "LogisticaContenidoRespuestaDTO");

// src/LogisticaGuiaDTO.ts
import { plainToClass, Type } from "class-transformer";

// src/utils/DateUtils.ts
var _DateUtils = class {
  static fromISOString(valor) {
    const date = new Date(valor);
    return _DateUtils.convertDateToUTC(date);
  }
  static fechaEsHoy(fecha) {
    const today = /* @__PURE__ */ new Date();
    today.setHours(0, 0, 0, 0);
    const dateToCheck = new Date(fecha);
    dateToCheck.setHours(0, 0, 0, 0);
    return dateToCheck.getTime() === today.getTime();
  }
  /**
   * Esta versión la codifiqué a mano. fromISOString() es más automatizada.
   * Hice esta antes de descubrir que la corrección consistía en actualizar el driver (npm install mssql)
   * Y estuve experimentando mil cosas!
   * @param valor cadena en formato yyyyMMdd o yyyy-MM-dd
   * @returns Date() resultante en timezone local
   */
  static fromISOStringHardCoded(valor) {
    if (/(20\d{2})-(\d{2})-(\d{2})/.test(valor)) {
      const arregloPartido = valor.split("-");
      const anio = Number(arregloPartido[0]);
      const mes = Number(arregloPartido[1]) - 1;
      const dia = Number(arregloPartido[2].substring(0, 2));
      return new Date(anio, mes, dia, 0, 0, 0);
    } else if (/(20\d{2})(\d{2})(\d{2})/.test(valor)) {
      const anio = Number(valor.substring(0, 4));
      const mes = Number(valor.substring(4, 6)) - 1;
      const dia = Number(valor.substring(6, 8));
      return new Date(anio, mes, dia, 0, 0, 0);
    } else {
      throw new Error(`La cadena ${valor} no coincide con los formatos admitidos: yyyyMMdd, yyyy-MM-dd`);
    }
  }
  //Ref https://stackoverflow.com/a/14006555/1436476
  static createDateAsUTC(date) {
    if (date) {
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
    } else {
      return date;
    }
  }
  static createDateAsUTCWithUTCParts(date) {
    if (date) {
      return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()));
    } else {
      return date;
    }
  }
  static convertDateToUTC(date) {
    if (date) {
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    } else {
      return date;
    }
  }
  static DateDiff(datePart, fechaMasAntigua, fechaMasReciente) {
    const fechaMasAntiguaDate = new Date(new Date(fechaMasAntigua).toDateString());
    const fechaMasRecienteDate = new Date(new Date(fechaMasReciente).toDateString());
    const time = fechaMasRecienteDate.getTime() - fechaMasAntiguaDate.getTime();
    let retorno = -1;
    switch (datePart) {
      case 3:
        retorno = Math.floor(time / 1e3);
        break;
      case 2:
        retorno = Math.floor(time / (1e3 * 60));
        break;
      case 0:
        retorno = Math.floor(time / (1e3 * 86400));
        break;
      case 1:
        retorno = Math.floor(fechaMasReciente.getFullYear() - fechaMasAntigua.getFullYear());
        break;
    }
    return retorno;
  }
};
var DateUtils = _DateUtils;
__name(DateUtils, "DateUtils");
/**
 * Se usa como un id=0 para las consultas de fecha
 */
__publicField(DateUtils, "Enero2000", "2000-01-01");

// src/utils/StringUtils.ts
function leftSpaces(x, length) {
  if (x.length > length) {
    x = x.substr(0, length);
  } else {
    const dif = length - x.length;
    if (dif > 0) {
      for (let i = 0; i < dif; i++) {
        x = " " + x;
      }
    }
  }
  return x;
}
__name(leftSpaces, "leftSpaces");
function rightSpaces(x, length) {
  if (x.length > length) {
    x = x.substr(0, length);
  } else {
    const dif = length - x.length;
    if (dif > 0) {
      for (let i = 0; i < dif; i++) {
        x = x + " ";
      }
    }
  }
  return x;
}
__name(rightSpaces, "rightSpaces");
function maxLength(str, length) {
  if (str.length > length) {
    return str.substr(0, length - 3) + "...";
  } else {
    return str;
  }
}
__name(maxLength, "maxLength");
function EsNumeroCompletoValido(str) {
  const regEx = /([0-9][0-9][0-9]-[0-9][0-9][0-9]-[0-9]+)/;
  if (!str.match(regEx)) {
    throw Error(`Error en el n\xFAmero ${str}, siga el formato 001-001-1234`);
  }
  ;
  return true;
}
__name(EsNumeroCompletoValido, "EsNumeroCompletoValido");
function EsFechaValida(str) {
  const regEx = /^\d{4}-\d{2}-\d{2}$/;
  if (!str.match(regEx))
    return false;
  const d = new Date(str.toString());
  const dNum = d.getTime();
  if (!dNum && dNum !== 0)
    return false;
  return d.toISOString().slice(0, 10) === str;
}
__name(EsFechaValida, "EsFechaValida");
function stringToNumber(str) {
  const result = Number(str);
  return isNaN(result) ? 0 : result;
}
__name(stringToNumber, "stringToNumber");

// src/LogisticaGuiaDTO.ts
function _ts_decorate2(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate2, "_ts_decorate");
function _ts_metadata2(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
}
__name(_ts_metadata2, "_ts_metadata");
var LogisticaGuiaDTO = class {
  constructor(id, idDocumento, TipoRango, serie1, serie2, numeroDocumento, fecha, idRemitente, idDestinatario, GuiasRemision, Facturas, observacion, idCiudadOrigen, idCiudadDestino, entregaUrgente, direccionDestinatario, telefonoDestinatario, Detalle, TipoFormaPago, TipoEntrega, Seguro, numeroRetencion, valorRetencionIR, iva, total, Usuario, fechaEntrega, longitud, latitud, latitudDestino, longitudDestino, UsuarioEntrega, estado, fotos, Gestiones, pesoKg, bultos) {
    __publicField(this, "id");
    __publicField(this, "idDocumento", Docs.GUIA_TRANSPORTE);
    __publicField(this, "TipoRango", LogisticaTiposRango.Cliente);
    __publicField(this, "serie1", "000");
    __publicField(this, "serie2", "000");
    __publicField(this, "numeroDocumento", 0);
    __publicField(this, "fecha", "");
    __publicField(this, "idRemitente", 0);
    __publicField(this, "idDestinatario", 0);
    __publicField(this, "GuiasRemision", []);
    __publicField(this, "GuiasRemisionNumeroCompleto", []);
    __publicField(this, "Facturas", []);
    __publicField(this, "FacturasNumeroCompleto", []);
    __publicField(this, "observacion", "");
    __publicField(this, "idCiudadOrigen", 0);
    __publicField(this, "idCiudadDestino", 0);
    __publicField(this, "entregaUrgente", false);
    __publicField(this, "direccionDestinatario", "");
    __publicField(this, "telefonoDestinatario", "");
    __publicField(this, "Detalle", []);
    __publicField(this, "TipoFormaPago", LogisticaTiposFormaPago.Credito);
    __publicField(this, "TipoEntrega", LogisticaTiposEntrega.Domicilio);
    __publicField(this, "Seguro");
    __publicField(this, "numeroRetencion");
    __publicField(this, "valorRetencionIR");
    __publicField(this, "iva", new BigDecimal(0));
    __publicField(this, "total", new BigDecimal(0));
    __publicField(this, "Usuario", "");
    __publicField(this, "fechaEntrega");
    __publicField(this, "longitud");
    __publicField(this, "latitud");
    __publicField(this, "latitudDestino");
    __publicField(this, "longitudDestino");
    __publicField(this, "UsuarioEntrega");
    __publicField(this, "estado");
    __publicField(this, "fotos");
    __publicField(this, "Gestiones", []);
    __publicField(this, "pesoKg");
    __publicField(this, "bultos");
    this.id = id;
    this.idDocumento = idDocumento;
    this.TipoRango = TipoRango;
    this.serie1 = serie1;
    this.serie2 = serie2;
    this.numeroDocumento = numeroDocumento;
    this.fecha = fecha;
    this.idRemitente = idRemitente;
    this.idDestinatario = idDestinatario;
    this.observacion = observacion;
    this.idCiudadOrigen = idCiudadOrigen;
    this.idCiudadDestino = idCiudadDestino;
    this.entregaUrgente = entregaUrgente;
    this.direccionDestinatario = direccionDestinatario;
    this.telefonoDestinatario = telefonoDestinatario;
    this.Detalle = Detalle;
    this.TipoFormaPago = TipoFormaPago;
    this.TipoEntrega = TipoEntrega;
    this.Seguro = Seguro;
    this.numeroRetencion = numeroRetencion;
    this.valorRetencionIR = valorRetencionIR;
    this.iva = iva;
    this.total = total;
    this.Usuario = Usuario;
    this.fechaEntrega = fechaEntrega;
    this.longitud = longitud;
    this.latitud = latitud;
    this.latitudDestino = latitudDestino;
    this.longitudDestino = longitudDestino;
    this.UsuarioEntrega = UsuarioEntrega;
    this.estado = estado;
    this.fotos = fotos;
    this.Gestiones = Gestiones;
    this.pesoKg = pesoKg;
    this.bultos = bultos;
    for (const gr of GuiasRemision) {
      this.GuiasRemision.push(gr.numeroDocumento);
      this.GuiasRemisionNumeroCompleto.push(gr.numeroCompleto);
    }
    for (const fr of Facturas) {
      this.Facturas.push(fr.numeroDocumento);
      this.FacturasNumeroCompleto.push(fr.numeroCompleto);
    }
  }
  validar() {
    if ([
      Docs.GUIA_TRANSPORTE,
      Docs.FACTURA
    ].indexOf(this.idDocumento) == -1) {
      throw Error("'idDocumento' debe ser 38 (GUIA) o 1 (FACTURA)");
    }
    if (this.TipoRango == LogisticaTiposRango.Factura && this.idDocumento != Docs.FACTURA) {
      throw Error("El TipoRango 'F' (Factura) debe ser usado con Documento 1 (FACTURA)");
    }
    if (this.idDocumento == Docs.FACTURA) {
      throw Error("Actualmente la API no soporta idDocumento = 1 (FACTURA)");
    }
    if (this.TipoRango == LogisticaTiposRango.Cliente && this.idDocumento != Docs.GUIA_TRANSPORTE) {
      throw Error("El TipoRango 'C' (Cliente) debe ser usado con Documento 38 (GUIA)");
    }
    if (this.serie1 == "000") {
      throw Error("'serie1' no puede estar vac\xEDo ni ser 000");
    }
    if (this.serie2 == "000") {
      throw Error("'serie2' no puede estar vac\xEDo ni ser 000");
    }
    if (this.numeroDocumento <= 0) {
      throw Error("'numeroDocumento' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (!EsFechaValida(this.fecha)) {
      throw Error("'fecha' tiene formato inv\xE1lido. Debe ser yyyy-MM-dd");
    }
    if (!DateUtils.fechaEsHoy(DateUtils.fromISOString(this.fecha))) {
      throw Error(`'fecha' ${this.fecha} debe ser hoy`);
    }
    if (this.idRemitente <= 0) {
      throw Error("'idRemitente' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.idDestinatario <= 0) {
      throw Error("'idDestinatario' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (!this.Facturas.length && !this.GuiasRemision.length) {
      throw Error("'Facturas[]' y 'GuiasRemision[]' no pueden estar vac\xEDos. Especifique al menos uno de ellos.");
    }
    if (this.idCiudadOrigen <= 0) {
      throw Error("'idCiudadOrigen' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.idCiudadDestino <= 0) {
      throw Error("'idCiudadDestino' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (!this.Detalle.length) {
      throw Error("'Contenido[]' no puede estar vac\xEDo.");
    }
    let iva = new BigDecimal(0);
    let total = new BigDecimal(0);
    for (let c of this.Detalle) {
      c.validar();
      iva = iva.plus(c.iva);
      total = total.plus(c.total);
    }
    if (!iva.equals(this.iva)) {
      throw Error(`La sumatoria de iva de los contenidos ${iva.toFixed(2)} es diferente de la cabecera ${this.iva.toFixed(2)}`);
    }
    if (!total.equals(this.total)) {
      throw Error(`La sumatoria de total de los contenidos ${total.toFixed(2)} es diferente de la cabecera ${this.total.toFixed(2)}`);
    }
    if (!ExisteEnEnum(LogisticaTiposEntrega, this.TipoEntrega)) {
      throw Error(`No se reconoce 'TipoEntrega' '${this.TipoEntrega}'. Debe ser 'D' (Domicilio) u 'O' (Retiro en oficina)`);
    }
    if (this.Seguro) {
      const instancia = plainToClass(LogisticaGuiaSeguroDTO, this.Seguro);
      instancia.validar();
      if (!this.Seguro.pagado) {
        if (this.TipoFormaPago != LogisticaTiposFormaPago.Credito) {
          throw Error("El seguro debe venir pagado si la forma de pago no es cr\xE9dito");
        }
      }
    }
    if (this.valorRetencionIR) {
      if (this.valorRetencionIR.lessThan(0)) {
        throw Error("'valorRetencionIR' no puede estar vac\xEDo y debe ser mayor que o igual a 0");
      } else if (this.valorRetencionIR.greaterThan(0)) {
        if (this.numeroRetencion) {
          EsNumeroCompletoValido(this.numeroRetencion);
        } else {
          throw Error("Si valorRetencionIR es mayor que cero debe especificar tambien numeroRetencion en formato 001-001-1234");
        }
      }
    }
    if (this.iva.lessThan(0)) {
      throw Error("'iva' no puede estar vac\xEDo y debe ser mayor que o igual a 0");
    }
    if (this.total.lessThanOrEqualTo(0)) {
      throw Error("'total' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    return true;
  }
};
__name(LogisticaGuiaDTO, "LogisticaGuiaDTO");
_ts_decorate2([
  Type(() => LogisticaGuiaDetalleDTO),
  _ts_metadata2("design:type", Array)
], LogisticaGuiaDTO.prototype, "Detalle", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaDTO.prototype, "valorRetencionIR", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaDTO.prototype, "iva", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaDTO.prototype, "total", void 0);
_ts_decorate2([
  Type(() => LogisticaGestionDTO),
  _ts_metadata2("design:type", Array)
], LogisticaGuiaDTO.prototype, "Gestiones", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaDTO.prototype, "pesoKg", void 0);
var LogisticaGuiaCanalTradicionalDTO = class {
  constructor() {
    __publicField(this, "idDocumento", Docs.GUIA_TRANSPORTE);
    __publicField(this, "TipoRango", LogisticaTiposRango.Cliente);
    __publicField(this, "serie1", "000");
    __publicField(this, "serie2", "000");
    __publicField(this, "numeroDocumento", 0);
    __publicField(this, "observacion", "");
    __publicField(this, "idRemitente", 0);
    __publicField(this, "idDestinatario", 0);
    __publicField(this, "idCiudadOrigen", 0);
    __publicField(this, "idCiudadDestino", 0);
    __publicField(this, "fecha", "");
    __publicField(this, "GuiasRemision", []);
    __publicField(this, "Facturas", []);
    __publicField(this, "entregaUrgente", false);
    __publicField(this, "TipoFormaPago", LogisticaTiposFormaPago.Credito);
    __publicField(this, "TipoEntrega", LogisticaTiposEntrega.Domicilio);
    __publicField(this, "Detalle", []);
    __publicField(this, "iva", new BigDecimal(0));
    __publicField(this, "total", new BigDecimal(0));
    __publicField(this, "Seguro");
    __publicField(this, "numeroRetencion");
    __publicField(this, "valorRetencionIR");
    __publicField(this, "direccionDestinatario", "");
    __publicField(this, "telefonoDestinatario", "");
    __publicField(this, "pesoKg");
    __publicField(this, "bultos");
  }
  validar() {
    if (Docs.GUIA_TRANSPORTE != this.idDocumento) {
      throw Error("'idDocumento' debe ser 38 (GUIA)");
    }
    if (!this.serie1 || this.serie1 == "000") {
      throw Error("'serie1' no puede estar vac\xEDo ni ser 000");
    }
    if (!this.serie2 || this.serie2 == "000") {
      throw Error("'serie2' no puede estar vac\xEDo ni ser 000");
    }
    if (this.numeroDocumento <= 0) {
      throw Error("'numeroDocumento' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (!EsFechaValida(this.fecha)) {
      throw Error("'fecha' tiene formato inv\xE1lido. Debe ser yyyy-MM-dd");
    }
    if (!DateUtils.fechaEsHoy(DateUtils.fromISOString(this.fecha))) {
      throw Error(`'fecha' ${this.fecha} debe ser hoy`);
    }
    if (this.idRemitente <= 0) {
      throw Error("'idRemitente' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.idDestinatario <= 0) {
      throw Error("'idDestinatario' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (!this.direccionDestinatario || !this.telefonoDestinatario)
      throw new Error(`No se ha asignado el campo de "direccionDestinatario" y/o "telefonoDestinatario" `);
    if (!this.Facturas.length && !this.GuiasRemision.length) {
      throw Error("'Facturas[]' y 'GuiasRemision[]' no pueden estar vac\xEDos. Especifique al menos uno de ellos.");
    }
    if (this.idCiudadOrigen <= 0) {
      throw Error("'idCiudadOrigen' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.idCiudadDestino <= 0) {
      throw Error("'idCiudadDestino' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (!this.Detalle.length) {
      throw Error("'Contenido[]' no puede estar vac\xEDo.");
    }
    let iva = new BigDecimal(0);
    let total = new BigDecimal(0);
    for (let c of this.Detalle) {
      c.validar();
      iva = iva.plus(c.iva);
      total = total.plus(c.total);
    }
    if (!iva.equals(this.iva)) {
      throw Error(`La sumatoria de iva de los contenidos ${iva.toFixed(2)} es diferente de la cabecera ${this.iva.toFixed(2)}`);
    }
    if (!total.equals(this.total)) {
      throw Error(`La sumatoria de total de los contenidos ${total.toFixed(2)} es diferente de la cabecera ${this.total.toFixed(2)}`);
    }
    if (!ExisteEnEnum(LogisticaTiposEntrega, this.TipoEntrega)) {
      throw Error(`No se reconoce 'TipoEntrega' '${this.TipoEntrega}'. Debe ser 'D' (Domicilio) u 'O' (Retiro en oficina)`);
    }
    if (this.Seguro) {
      const instancia = plainToClass(LogisticaGuiaSeguroDTO, this.Seguro);
      instancia.validar();
      if (!this.Seguro.pagado) {
        if (this.TipoFormaPago != LogisticaTiposFormaPago.Credito) {
          throw Error("El seguro debe venir pagado si la forma de pago no es cr\xE9dito");
        }
      }
    }
    if (this.valorRetencionIR) {
      if (this.valorRetencionIR.lessThan(0)) {
        throw Error("'valorRetencionIR' no puede estar vac\xEDo y debe ser mayor que o igual a 0");
      } else if (this.valorRetencionIR.greaterThan(0)) {
        if (this.numeroRetencion) {
          EsNumeroCompletoValido(this.numeroRetencion);
        } else {
          throw Error("Si valorRetencionIR es mayor que cero debe especificar tambien numeroRetencion en formato 001-001-1234");
        }
      }
    }
    if (this.iva.lessThan(0)) {
      throw Error("'iva' no puede estar vac\xEDo y debe ser mayor que o igual a 0");
    }
    if (this.total.lessThanOrEqualTo(0)) {
      throw Error("'total' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    return true;
  }
};
__name(LogisticaGuiaCanalTradicionalDTO, "LogisticaGuiaCanalTradicionalDTO");
_ts_decorate2([
  Type(() => LogisticaGuiaDetalleDTO),
  _ts_metadata2("design:type", Array)
], LogisticaGuiaCanalTradicionalDTO.prototype, "Detalle", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaCanalTradicionalDTO.prototype, "iva", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaCanalTradicionalDTO.prototype, "total", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaCanalTradicionalDTO.prototype, "valorRetencionIR", void 0);
var LogisticaGuiaCanalModernoDTO = class {
  constructor() {
    __publicField(this, "idDocumento", Docs.GUIA_TRANSPORTE);
    __publicField(this, "TipoRango", LogisticaTiposRango.Cliente);
    __publicField(this, "serie1", "000");
    __publicField(this, "serie2", "000");
    __publicField(this, "numeroDocumento", 0);
    __publicField(this, "observacion", "");
    __publicField(this, "idCiudadOrigen", 0);
    __publicField(this, "idCiudadDestino", 0);
    __publicField(this, "fecha", "");
    __publicField(this, "GuiasRemision", []);
    __publicField(this, "Facturas", []);
    __publicField(this, "identificacionRemitente", "");
    __publicField(this, "Destinatario");
    __publicField(this, "entregaUrgente", false);
    __publicField(this, "TipoFormaPago", LogisticaTiposFormaPago.Credito);
    __publicField(this, "TipoEntrega", LogisticaTiposEntrega.Domicilio);
    __publicField(this, "pesoKg");
    __publicField(this, "bultos");
  }
  validar() {
    var _a, _b, _c;
    if (Docs.GUIA_TRANSPORTE != this.idDocumento) {
      throw Error("'idDocumento' debe ser 38 (GUIA)");
    }
    if (!this.serie1 || this.serie1 == "000") {
      throw Error("'serie1' no puede estar vac\xEDo ni ser 000");
    }
    if (!this.serie2 || this.serie2 == "000") {
      throw Error("'serie2' no puede estar vac\xEDo ni ser 000");
    }
    if (!EsFechaValida(this.fecha)) {
      throw Error("'fecha' tiene formato inv\xE1lido. Debe ser yyyy-MM-dd");
    }
    if (!DateUtils.fechaEsHoy(DateUtils.fromISOString(this.fecha))) {
      throw Error(`'fecha' ${this.fecha} debe ser hoy`);
    }
    if (!this.identificacionRemitente) {
      throw Error("Especifique el campo 'identificacionRemitente'");
    }
    if (!this.Destinatario) {
      throw Error("Especifique el campo 'Destinatario'");
    }
    if (!this.Destinatario.direccion) {
      throw Error(`No se ha definido la direcci\xF3n del destinatario`);
    }
    if (!this.Destinatario.telefono) {
      throw Error(`No se ha definido el tel\xE9fono del destinatario`);
    }
    if (!((_a = this.Facturas) == null ? void 0 : _a.length) && !((_b = this.GuiasRemision) == null ? void 0 : _b.length)) {
      throw Error("'Facturas[]' y 'GuiasRemision[]' no pueden estar vac\xEDos. Especifique al menos uno de ellos.");
    }
    if (this.idCiudadOrigen <= 0) {
      throw Error("'idCiudadOrigen' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.idCiudadDestino <= 0) {
      throw Error("'idCiudadDestino' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if ((_c = this.pesoKg) == null ? void 0 : _c.lessThanOrEqualTo(0)) {
      throw Error("El campo 'pesoKG' debe ser mayor a 0");
    }
    if (this.bultos && this.bultos <= 0) {
      throw Error("La cantidad de 'bultos' debe ser mayor que 0");
    }
    return true;
  }
};
__name(LogisticaGuiaCanalModernoDTO, "LogisticaGuiaCanalModernoDTO");
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", Boolean)
], LogisticaGuiaCanalModernoDTO.prototype, "entregaUrgente", void 0);
var LogisticaGuiaProformaDTO = class {
  constructor(id, idDocumento, TipoRango, serie1, serie2, numeroDocumento, fecha, idRemitente, idDestinatario, GuiasRemision, Facturas, observacion, idCiudadOrigen, idCiudadDestino, entregaUrgente, direccionDestinatario, telefonoDestinatario, Detalle, TipoFormaPago, TipoEntrega, Seguro, numeroRetencion, valorRetencionIR, iva, total, Usuario, fechaEntrega, longitud, latitud, UsuarioEntrega, fotos) {
    __publicField(this, "id");
    __publicField(this, "idDocumento", Docs.GUIA_TRANSPORTE);
    __publicField(this, "TipoRango", LogisticaTiposRango.Cliente);
    __publicField(this, "serie1", "000");
    __publicField(this, "serie2", "000");
    __publicField(this, "numeroDocumento", 0);
    __publicField(this, "fecha", "");
    __publicField(this, "idRemitente", 0);
    __publicField(this, "idDestinatario", 0);
    __publicField(this, "GuiasRemision", []);
    __publicField(this, "Facturas", []);
    __publicField(this, "observacion", "");
    __publicField(this, "idCiudadOrigen", 0);
    __publicField(this, "idCiudadDestino", 0);
    __publicField(this, "entregaUrgente", false);
    __publicField(this, "direccionDestinatario", "");
    __publicField(this, "telefonoDestinatario", "");
    __publicField(this, "Detalle", []);
    __publicField(this, "TipoFormaPago", LogisticaTiposFormaPago.Credito);
    __publicField(this, "TipoEntrega", LogisticaTiposEntrega.Domicilio);
    __publicField(this, "Seguro");
    __publicField(this, "numeroRetencion");
    __publicField(this, "valorRetencionIR");
    __publicField(this, "iva", new BigDecimal(0));
    __publicField(this, "total", new BigDecimal(0));
    __publicField(this, "Usuario", "");
    __publicField(this, "fechaEntrega");
    __publicField(this, "longitud");
    __publicField(this, "latitud");
    __publicField(this, "UsuarioEntrega");
    __publicField(this, "fotos");
    this.id = id;
    this.idDocumento = idDocumento;
    this.TipoRango = TipoRango;
    this.serie1 = serie1;
    this.serie2 = serie2;
    this.numeroDocumento = numeroDocumento;
    this.fecha = fecha;
    this.idRemitente = idRemitente;
    this.idDestinatario = idDestinatario;
    this.GuiasRemision = GuiasRemision;
    this.Facturas = Facturas;
    this.observacion = observacion;
    this.idCiudadOrigen = idCiudadOrigen;
    this.idCiudadDestino = idCiudadDestino;
    this.entregaUrgente = entregaUrgente;
    this.direccionDestinatario = direccionDestinatario;
    this.telefonoDestinatario = telefonoDestinatario;
    this.Detalle = Detalle;
    this.TipoFormaPago = TipoFormaPago;
    this.TipoEntrega = TipoEntrega;
    this.Seguro = Seguro;
    this.numeroRetencion = numeroRetencion;
    this.valorRetencionIR = valorRetencionIR;
    this.iva = iva;
    this.total = total;
    this.Usuario = Usuario;
    this.fechaEntrega = fechaEntrega;
    this.longitud = longitud;
    this.latitud = latitud;
    this.UsuarioEntrega = UsuarioEntrega;
    this.fotos = fotos;
  }
  validar() {
    if ([
      Docs.GUIA_TRANSPORTE,
      Docs.FACTURA
    ].indexOf(this.idDocumento) == -1) {
      throw Error("'idDocumento' debe ser 38 (GUIA) o 1 (FACTURA)");
    }
    if (this.TipoRango == LogisticaTiposRango.Factura && this.idDocumento != Docs.FACTURA) {
      throw Error("El TipoRango 'F' (Factura) debe ser usado con Documento 1 (FACTURA)");
    }
    if (this.idDocumento == Docs.FACTURA) {
      throw Error("Actualmente la API no soporta idDocumento = 1 (FACTURA)");
    }
    if (this.TipoRango == LogisticaTiposRango.Cliente && this.idDocumento != Docs.GUIA_TRANSPORTE) {
      throw Error("El TipoRango 'C' (Cliente) debe ser usado con Documento 38 (GUIA)");
    }
    if (this.serie1 == "000") {
      throw Error("'serie1' no puede estar vac\xEDo ni ser 000");
    }
    if (this.serie2 == "000") {
      throw Error("'serie2' no puede estar vac\xEDo ni ser 000");
    }
    if (this.numeroDocumento <= 0) {
      throw Error("'numeroDocumento' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (!EsFechaValida(this.fecha)) {
      throw Error("'fecha' tiene formato inv\xE1lido. Debe ser yyyy-MM-dd");
    }
    if (!DateUtils.fechaEsHoy(DateUtils.fromISOString(this.fecha))) {
      throw Error(`'fecha' ${this.fecha} debe ser hoy`);
    }
    if (this.idRemitente <= 0) {
      throw Error("'idRemitente' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.idDestinatario <= 0) {
      throw Error("'idDestinatario' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (!this.Facturas.length && !this.GuiasRemision.length) {
      throw Error("'Facturas[]' y 'GuiasRemision[]' no pueden estar vac\xEDos. Especifique al menos uno de ellos.");
    }
    if (this.idCiudadOrigen <= 0) {
      throw Error("'idCiudadOrigen' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.idCiudadDestino <= 0) {
      throw Error("'idCiudadDestino' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (!this.Detalle.length) {
      throw Error("'Contenido[]' no puede estar vac\xEDo.");
    }
    let iva = new BigDecimal(0);
    let total = new BigDecimal(0);
    for (let c of this.Detalle) {
      c.validar();
      iva = iva.plus(c.iva);
      total = total.plus(c.total);
    }
    if (!iva.equals(this.iva)) {
      throw Error(`La sumatoria de iva de los contenidos ${iva.toFixed(2)} es diferente de la cabecera ${this.iva.toFixed(2)}`);
    }
    if (!total.equals(this.total)) {
      throw Error(`La sumatoria de total de los contenidos ${total.toFixed(2)} es diferente de la cabecera ${this.total.toFixed(2)}`);
    }
    if (!ExisteEnEnum(LogisticaTiposEntrega, this.TipoEntrega)) {
      throw Error(`No se reconoce 'TipoEntrega' '${this.TipoEntrega}'. Debe ser 'D' (Domicilio) u 'O' (Retiro en oficina)`);
    }
    if (this.Seguro) {
      const instancia = plainToClass(LogisticaGuiaSeguroDTO, this.Seguro);
      instancia.validar();
      if (!this.Seguro.pagado) {
        if (this.TipoFormaPago != LogisticaTiposFormaPago.Credito) {
          throw Error("El seguro debe venir pagado si la forma de pago no es cr\xE9dito");
        }
      }
    }
    if (this.valorRetencionIR) {
      if (this.valorRetencionIR.lessThan(0)) {
        throw Error("'valorRetencionIR' no puede estar vac\xEDo y debe ser mayor que o igual a 0");
      } else if (this.valorRetencionIR.greaterThan(0)) {
        if (this.numeroRetencion) {
          EsNumeroCompletoValido(this.numeroRetencion);
        } else {
          throw Error("Si valorRetencionIR es mayor que cero debe especificar tambien numeroRetencion en formato 001-001-1234");
        }
      }
    }
    if (this.iva.lessThan(0)) {
      throw Error("'iva' no puede estar vac\xEDo y debe ser mayor que o igual a 0");
    }
    if (this.total.lessThanOrEqualTo(0)) {
      throw Error("'total' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    return true;
  }
};
__name(LogisticaGuiaProformaDTO, "LogisticaGuiaProformaDTO");
_ts_decorate2([
  Type(() => LogisticaGuiaProformaDetalleDTO),
  _ts_metadata2("design:type", Array)
], LogisticaGuiaProformaDTO.prototype, "Detalle", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaProformaDTO.prototype, "valorRetencionIR", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaProformaDTO.prototype, "iva", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaProformaDTO.prototype, "total", void 0);
var LogisticaGestionDTO = class {
  constructor(id, fechaCreacion, descripcion) {
    __publicField(this, "id");
    __publicField(this, "fechaCreacion");
    __publicField(this, "descripcion");
    this.id = id;
    this.fechaCreacion = fechaCreacion;
    this.descripcion = descripcion;
  }
};
__name(LogisticaGestionDTO, "LogisticaGestionDTO");
var LogisticaGuiaDetalleDTO = class {
  constructor(idContenido, idGuia, bultos, seguro, cantidad, precio, iva, total, subtotal, detalle, peso) {
    __publicField(this, "idContenido", 0);
    __publicField(this, "idGuia", 0);
    __publicField(this, "bultos", 0);
    __publicField(this, "seguro", false);
    __publicField(this, "cantidad", new BigDecimal(0));
    __publicField(this, "precio", new BigDecimal(0));
    __publicField(this, "iva", new BigDecimal(0));
    __publicField(this, "total", new BigDecimal(0));
    __publicField(this, "subtotal", new BigDecimal(0));
    __publicField(this, "detalle", "");
    __publicField(this, "peso");
    this.idContenido = idContenido;
    this.idGuia = idGuia;
    this.bultos = bultos;
    this.seguro = seguro;
    this.cantidad = cantidad;
    this.precio = precio;
    this.iva = iva;
    this.total = total;
    this.subtotal = subtotal;
    this.detalle = detalle;
    this.peso = peso;
  }
  validar() {
    const totalCalculado = this.precio.times(this.cantidad).plus(this.iva);
    const ivaCalculado = new BigDecimal(this.cantidad).times(this.precio).times("0.15");
    if (this.idContenido <= 0) {
      throw Error("'idContenido' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.cantidad.lessThanOrEqualTo(0)) {
      throw Error("'cantidad' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.bultos <= 0) {
      throw Error("'bultos' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.precio.lessThanOrEqualTo(0)) {
      throw Error("'precio' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.iva.lessThan(0)) {
      throw Error("'iva' no puede estar vac\xEDo y debe ser mayor que o igual a 0");
    }
    if (this.total.lessThanOrEqualTo(0)) {
      throw Error("'total' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (!totalCalculado.equals(this.total)) {
      throw Error(`'total' ${this.total.toString()} no coincide con (cantidad * precio + iva) ${totalCalculado.toString()}`);
    }
    const hayDescuadreIVA = ivaCalculado.minus(this.iva).abs() > new BigDecimal("0.01");
    if (this.iva.greaterThan(0) && hayDescuadreIVA) {
      throw Error(`'iva' enviado ${this.iva.toString()} no coincide con el calculado ${ivaCalculado.toString()}`);
    }
    if (!totalCalculado.equals(this.total)) {
      throw Error(`'total' ${this.total.toString()} no coincide con (cantidad * precio + iva) ${totalCalculado.toString()}`);
    }
    return true;
  }
};
__name(LogisticaGuiaDetalleDTO, "LogisticaGuiaDetalleDTO");
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaDetalleDTO.prototype, "cantidad", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaDetalleDTO.prototype, "precio", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaDetalleDTO.prototype, "iva", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaDetalleDTO.prototype, "total", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaDetalleDTO.prototype, "subtotal", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaDetalleDTO.prototype, "peso", void 0);
var LogisticaGuiaProformaDetalleDTO = class {
  constructor(idContenido, idGuiaProforma, bultos, seguro, cantidad, precio, iva, total, subtotal, detalle) {
    __publicField(this, "idContenido", 0);
    __publicField(this, "idGuiaProforma", 0);
    __publicField(this, "bultos", 0);
    __publicField(this, "seguro", false);
    __publicField(this, "cantidad", new BigDecimal(0));
    __publicField(this, "precio", new BigDecimal(0));
    __publicField(this, "iva", new BigDecimal(0));
    __publicField(this, "total", new BigDecimal(0));
    __publicField(this, "subtotal", new BigDecimal(0));
    __publicField(this, "detalle", "");
    this.idContenido = idContenido;
    this.idGuiaProforma = idGuiaProforma;
    this.bultos = bultos;
    this.seguro = seguro;
    this.cantidad = cantidad;
    this.precio = precio;
    this.iva = iva;
    this.total = total;
    this.subtotal = subtotal;
    this.detalle = detalle;
  }
  validar() {
    const totalCalculado = this.precio.times(this.cantidad).plus(this.iva);
    const ivaCalculado = new BigDecimal(this.cantidad.times(this.precio).times(new BigDecimal("0.12").toFixed(2)));
    if (this.idContenido <= 0) {
      throw Error("'idContenido' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.cantidad.lessThanOrEqualTo(0)) {
      throw Error("'cantidad' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.bultos <= 0) {
      throw Error("'bultos' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.precio.lessThanOrEqualTo(0)) {
      throw Error("'precio' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (this.iva.lessThan(0)) {
      throw Error("'iva' no puede estar vac\xEDo y debe ser mayor que o igual a 0");
    }
    if (this.total.lessThanOrEqualTo(0)) {
      throw Error("'total' no puede estar vac\xEDo y debe ser mayor que 0");
    }
    if (!totalCalculado.equals(this.total)) {
      throw Error(`'total' ${this.total.toString()} no coincide con (cantidad * precio + iva) ${totalCalculado.toString()}`);
    }
    if (this.iva.greaterThan(0) && !this.iva.equals(ivaCalculado)) {
      throw Error(`'iva' enviado ${this.iva.toString()} no coincide con el calculado ${ivaCalculado.toString()}`);
    }
    return true;
  }
};
__name(LogisticaGuiaProformaDetalleDTO, "LogisticaGuiaProformaDetalleDTO");
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaProformaDetalleDTO.prototype, "cantidad", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaProformaDetalleDTO.prototype, "precio", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaProformaDetalleDTO.prototype, "iva", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaProformaDetalleDTO.prototype, "total", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaProformaDetalleDTO.prototype, "subtotal", void 0);
var LogisticaGuiaSeguroDTO = class {
  constructor(valorDeclarado, valorSeguro, iva, total, pagado, valorRetencionIR, valorRetencionIVA, numeroRetencion) {
    __publicField(this, "valorDeclarado", new BigDecimal(0));
    __publicField(this, "valorSeguro", new BigDecimal(0));
    __publicField(this, "iva", new BigDecimal(0));
    __publicField(this, "total", new BigDecimal(0));
    __publicField(this, "pagado", true);
    __publicField(this, "valorRetencionIR", new BigDecimal(0));
    __publicField(this, "valorRetencionIVA", new BigDecimal(0));
    __publicField(this, "numeroRetencion", "");
    this.valorDeclarado = valorDeclarado;
    this.valorSeguro = valorSeguro;
    this.iva = iva;
    this.total = total;
    this.pagado = pagado;
    this.valorRetencionIR = valorRetencionIR;
    this.valorRetencionIVA = valorRetencionIVA;
    this.numeroRetencion = numeroRetencion;
  }
  validar() {
    if (this.valorDeclarado.greaterThan(0) && this.valorSeguro.lessThanOrEqualTo(0)) {
      throw Error("Valor seguro debe ser mayor que 0 cuando el valor declarado es mayor que cero");
    }
    if (this.valorRetencionIR.greaterThan(0) || this.valorRetencionIVA.greaterThan(0)) {
      EsNumeroCompletoValido(this.numeroRetencion);
    }
    return true;
  }
};
__name(LogisticaGuiaSeguroDTO, "LogisticaGuiaSeguroDTO");
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaSeguroDTO.prototype, "valorDeclarado", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaSeguroDTO.prototype, "valorSeguro", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaSeguroDTO.prototype, "iva", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaSeguroDTO.prototype, "total", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaSeguroDTO.prototype, "valorRetencionIR", void 0);
_ts_decorate2([
  ClassTransformerBigDecimalTransform(),
  _ts_metadata2("design:type", typeof BigDecimal === "undefined" ? Object : BigDecimal)
], LogisticaGuiaSeguroDTO.prototype, "valorRetencionIVA", void 0);

// src/LogisticaGuiaEntregaBody.ts
var LogisticaGuiaEntregaBody = class {
  constructor(id, Usuario, latitud, longitud, fecha) {
    __publicField(this, "id", 0);
    __publicField(this, "Usuario", "");
    __publicField(this, "latitud");
    __publicField(this, "longitud");
    /**
     * Si no se especifica, se asigna la fecha actual
     */
    __publicField(this, "fecha");
    this.id = id;
    this.Usuario = Usuario;
    this.latitud = latitud;
    this.longitud = longitud;
    this.fecha = fecha;
  }
};
__name(LogisticaGuiaEntregaBody, "LogisticaGuiaEntregaBody");

// src/utils/Numeracion.ts
var Numeracion = class {
  constructor(numeracion_serie1, serie2, numeroDocumento) {
    __publicField(this, "serie1", "");
    __publicField(this, "serie2", "");
    __publicField(this, "numeroDocumento", 0);
    __publicField(this, "numeroCompleto", "");
    __publicField(this, "esValido", false);
    if (serie2 === void 0 && numeroDocumento === void 0) {
      const _numeroCompleto = String(numeracion_serie1);
      this.numeroCompleto = _numeroCompleto;
      const partes = _numeroCompleto.split("-");
      if (partes.length === 3) {
        this.serie1 = partes[0];
        this.serie2 = partes[1];
        const num2 = Number(partes[2]);
        if (!isNaN(num2)) {
          this.numeroDocumento = num2;
          this.esValido = true;
        }
        return;
      }
      const num = Number(_numeroCompleto);
      if (!isNaN(num)) {
        this.numeroDocumento = num;
        this.esValido = true;
      }
      return;
    }
    const _serie1 = numeracion_serie1;
    this.serie1 = _serie1;
    this.serie2 = serie2;
    this.numeroDocumento = numeroDocumento;
    this.numeroCompleto = `${_serie1}-${serie2}-${numeroDocumento}`;
    this.esValido = true;
  }
  esNumeroCompleto() {
    return this.serie1.trim() !== "" && this.serie2.trim() !== "" && this.numeroDocumento > 0;
  }
};
__name(Numeracion, "Numeracion");

// src/utils/LogisticaGuiaUtils.ts
var formatDocumentosRelacionados = /* @__PURE__ */ __name((guia) => {
  if (!guia.logistica_GUIA_DOCUMENTO_RELACIONES || guia.logistica_GUIA_DOCUMENTO_RELACIONES.length === 0) {
    return "-";
  }
  const facturas = [];
  const guiasRemision = [];
  guia.logistica_GUIA_DOCUMENTO_RELACIONES.forEach((rel) => {
    const numeroCompleto = rel.serie1 && rel.serie2 ? `${rel.serie1}-${rel.serie2}-${rel.numeroDocumento}` : rel.numeroDocumento.toString();
    if (rel.idDocumentoSRI === SriDocs.Factura) {
      facturas.push(numeroCompleto);
    } else if (rel.idDocumentoSRI === SriDocs.Guia_Remisi\u00F3n) {
      guiasRemision.push(numeroCompleto);
    }
  });
  const partes = [];
  if (facturas.length > 0) {
    partes.push(`F: ${facturas.join("; ")}`);
  }
  if (guiasRemision.length > 0) {
    partes.push(`G: ${guiasRemision.join("; ")}`);
  }
  return partes.join(" | ") || "-";
}, "formatDocumentosRelacionados");
var getEstadoGuiaTexto = /* @__PURE__ */ __name((estado) => {
  switch (estado) {
    case LogisticaGuiaEstado.Planta:
      return "En planta";
    case LogisticaGuiaEstado.Viaje:
      return "Enviado";
    case LogisticaGuiaEstado.RecibidoEnBodegaTransito:
      return "En bodega";
    case LogisticaGuiaEstado.Ruta:
      return "En ruta";
    case LogisticaGuiaEstado.Entregada:
      return "Entregada";
    case LogisticaGuiaEstado.Anulado:
      return "Anulado";
    case LogisticaGuiaEstado.Recibido:
      return "Recibido";
    case LogisticaGuiaEstado.Devuelta:
      return "Devuelta";
    case LogisticaGuiaEstado.EnViajeBodegaTransito:
      return "En viaje desde bodega";
    case LogisticaGuiaEstado.Conflicto:
      return "Conflicto";
    default:
      return estado || "??";
  }
}, "getEstadoGuiaTexto");
export {
  AppsDeOrigen,
  BigDecimal,
  CiudadDTO,
  ClienteDTO,
  CoberturaDTO,
  CobroDTO,
  ConfiguracionesCorreo,
  ConfiguracionesEmpresa,
  ConstantesDocumentos,
  ContaDocs,
  CuentasEnlace,
  DateRange,
  DateUtils,
  Docs,
  DocumentoDominio,
  E_AMBIENTE,
  Ecuador,
  EnviarCorreoBody,
  EsFechaValida,
  EsNumeroCompletoValido,
  ExisteEnEnum,
  FormasPagoEspeciales,
  HTTP_STATUS,
  LoginRequestBody,
  LogisticaContenidoDTO,
  LogisticaContenidoPorDestinoDTO,
  LogisticaContenidoPorTipoDestinoDTO,
  LogisticaContenidoRespuestaDTO,
  LogisticaEstadoConversion,
  LogisticaGestionDTO,
  LogisticaGuiaCanalModernoDTO,
  LogisticaGuiaCanalTradicionalDTO,
  LogisticaGuiaDTO,
  LogisticaGuiaDetalleDTO,
  LogisticaGuiaEntregaBody,
  LogisticaGuiaEstado,
  LogisticaGuiaProformaDTO,
  LogisticaGuiaProformaDetalleDTO,
  LogisticaGuiaProformaEstado,
  LogisticaGuiaSeguroDTO,
  LogisticaManifiestoDetalleEstado,
  LogisticaManifiestoProformaEstado,
  LogisticaTipoCanal,
  LogisticaTipoConversion,
  LogisticaTipoFormaPagoDominio,
  LogisticaTiposEntrega,
  LogisticaTiposFormaPago,
  LogisticaTiposRango,
  Modulos,
  MovimientoCabeceraObservacionesEspeciales,
  Movs,
  NivelLog,
  Notificaciones,
  Numeracion,
  Permisos,
  SriDocs,
  TablasTransacciones,
  TipoCanalVenta,
  TipoContenido,
  TiposAPI,
  TiposDocumento,
  TiposEmision,
  TiposFormaPago,
  TiposIVA,
  TiposIdentificacion,
  TiposPago,
  TiposVisita,
  TiposVisitaSegunUbicacion,
  estadoLogisticaManifiestoProformaDetalle,
  estadoMOVIMIENTOCABECERA,
  estadoUsuario,
  formatDocumentosRelacionados,
  getEstadoGuiaTexto,
  leftSpaces,
  logisticaManifiestoDetalleEstado,
  logisticaManifiestoEstado,
  logisticaOrigen,
  logisticaTipoContenido,
  logisticaTipoContenidoDominio,
  logisticaTipoMedida,
  maxLength,
  porcentajeIVA,
  rightSpaces,
  stringToNumber,
  tiposImporteCabecera
};
